/* Vesper Cocktails store locator (StoreLocator.dc.html port).
   Data: the shop metafield store_locator.stores, injected by sections/vc-locator-finder.liquid
   as <script type="application/json" data-vcl-data> (rows: n a c r p k w lat lng ap; written by
   the store-locator pipeline's publish.py). No network request for the store list. Rows without
   coordinates are skipped; ap: 1 rows get an "approximate pin" note in the list and the card.
   Phones (max-width 749px) list 6 stores, then "Show more" adds 6 at a time. Map: Leaflet +
   OpenStreetMap tiles.
   Geocoding: Nominatim, one request per explicit submit (never while typing), cached
   per session, at most one request per second.
   The map mirrors the mockup's OpenStreetMap embed: centred on the selected store at the same
   bbox (lat +-0.045, lon +-0.072), default Leaflet pin, whole map greyscale/sepia filtered (CSS). */
(function () {
  'use strict';
  if (window.VCLocator) return;

  var LEAFLET_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var LEAFLET_JS_SRI = 'sha512-puJW3E/qXDqYp9IfhAI54BJEaWIfloJ7JWs7OeD5i6ruC9JZL1gERT1wjtwXFlh7CjE7ZJ+/vcRZRkIYIb6p4g==';
  var LEAFLET_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var LEAFLET_CSS_SRI = 'sha512-h9FcoyWjHcOcmEVkxOfTLnmZFWIH0iZhZT1H2TbOq55xssQGEJHEaIm+PgoUaZbRvQTNTluNOEfb1ZRy6D3BOw==';
  var TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  var TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors';
  var NOMINATIM = 'https://nominatim.openstreetmap.org/search';
  var LEAFLET_IMG = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/';
  var BBOX_LAT = 0.045, BBOX_LON = 0.045 * 1.6; // StoreLocator.dc.html mapSrc bbox

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- loaders ---------- */
  var leafletP = null;
  function loadLeaflet() {
    if (window.L && window.L.map) return Promise.resolve(window.L);
    if (leafletP) return leafletP;
    leafletP = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-vc-leaflet]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = LEAFLET_CSS; l.integrity = LEAFLET_CSS_SRI; l.crossOrigin = 'anonymous';
        l.setAttribute('data-vc-leaflet', '');
        document.head.appendChild(l);
      }
      var s = document.createElement('script');
      s.src = LEAFLET_JS; s.integrity = LEAFLET_JS_SRI; s.crossOrigin = 'anonymous'; s.async = true;
      s.onload = function () { resolve(window.L); };
      s.onerror = function () { leafletP = null; reject(new Error('leaflet')); };
      document.head.appendChild(s);
    });
    return leafletP;
  }

  /* ---------- data ---------- */
  function clean(v) { return v == null ? '' : String(v).replace(/\s+/g, ' ').trim(); }
  function validCoord(lat, lon) {
    // The stores are all in Canada and the US; anything outside North America is a bad pin.
    return isFinite(lat) && isFinite(lon) && lat > 18 && lat < 72 && lon > -170 && lon < -50;
  }
  // The JSON the section injects; null when the metafield is missing or unreadable.
  function readData(root) {
    var el = root.querySelector('script[data-vcl-data]');
    if (!el) return null;
    try {
      var rows = JSON.parse(el.textContent || 'null');
      return Array.isArray(rows) ? normalize(rows) : null;
    } catch (e) { return null; }
  }
  function normalize(rows) {
    var out = [];
    rows.forEach(function (r, i) {
      if (!r || typeof r !== 'object') return;
      var name = clean(r.n);
      if (!name || r.lat == null || r.lng == null || r.lat === '' || r.lng === '') return;
      var lat = Number(r.lat), lon = Number(r.lng);
      if (!validCoord(lat, lon)) return; // no usable pin: not listed
      var city = clean(r.c), region = clean(r.r).toUpperCase(), postal = clean(r.p);
      var k = clean(r.k).toUpperCase();
      var country = k === 'CA' || k === 'US' ? k : '';
      // An empty address falls back to city, region and postal code.
      var addr = clean(r.a) || [city, [region, postal].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      var approx = r.ap === 1 || r.ap === '1';
      // An approximate row whose address starts with its town has no street address.
      var noStreet = approx && !!city && addr.split(',')[0].trim().toLowerCase() === city.toLowerCase();
      out.push({
        id: 's' + i,
        name: name,
        addr: addr,
        city: city,
        region: region,
        postal: postal,
        country: country,
        lat: lat,
        lon: lon,
        approx: approx,
        noStreet: noStreet,
        hay: (name + ' ' + addr + ' ' + city + ' ' + region + ' ' + postal + ' ' +
          (country === 'CA' ? 'canada' : country === 'US' ? 'usa united states' : '')).toLowerCase(),
        nameL: name.toLowerCase()
      });
    });
    out.sort(function (a, b) { return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
    return out;
  }

  /* ---------- geocoding ---------- */
  var lastGeo = 0;
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function cacheGet(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : undefined; } catch (e) { return undefined; } }
  function cacheSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function geocode(q) {
    var key = 'vc-locator:geo:' + q.toLowerCase();
    var hit = cacheGet(key);
    if (hit !== undefined) return Promise.resolve(hit);
    var wait = Math.max(0, lastGeo + 1100 - Date.now());
    return sleep(wait).then(function () {
      lastGeo = Date.now();
      var lang = (document.documentElement.lang || 'en').slice(0, 2);
      var url = NOMINATIM + '?format=jsonv2&limit=1&addressdetails=1&countrycodes=ca,us&accept-language=' + encodeURIComponent(lang) + '&q=' + encodeURIComponent(q);
      return fetch(url, { credentials: 'omit' });
    }).then(function (r) { if (!r.ok) throw new Error('geo ' + r.status); return r.json(); })
      .then(function (d) {
        var g = null;
        if (d && d[0]) {
          var a = d[0].address || {};
          var label = a.city || a.town || a.village || a.municipality || a.postcode || (d[0].display_name || q).split(',')[0];
          g = { lat: parseFloat(d[0].lat), lon: parseFloat(d[0].lon), label: label, unit: (a.country_code === 'us' ? 'mi' : 'km') };
        }
        cacheSet(key, g);
        return g;
      });
  }

  function haversineKm(aLat, aLon, bLat, bLon) {
    var R = 6371, toR = Math.PI / 180;
    var dLat = (bLat - aLat) * toR, dLon = (bLon - aLon) * toR;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(aLat * toR) * Math.cos(bLat * toR) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }
  function fmtDist(km, unit) {
    if (km == null) return '';
    var v = unit === 'mi' ? km * 0.621371 : km;
    return (v < 10 ? v.toFixed(1) : Math.round(v)) + ' ' + unit;
  }

  /* ---------- instance ---------- */
  function Locator(root) {
    this.root = root;
    this.cfg = {
      radius: parseFloat(root.getAttribute('data-radius')) || 150,
      nearest: 10,
      page: 6 // stores per page on phones
    };
    this.t = {
      stores: root.getAttribute('data-l-stores') || 'Stores',
      store: root.getAttribute('data-l-store') || 'Store',
      searching: root.getAttribute('data-l-searching') || 'Searching',
      loading: root.getAttribute('data-l-loading') || 'Loading stores',
      empty: root.getAttribute('data-l-empty') || 'No stores match that search.',
      emptyHint: root.getAttribute('data-l-empty-hint') || 'Press Search to look for stores nearby.',
      notFound: root.getAttribute('data-l-notfound') || 'We could not find that location. Try a city or a full postal or ZIP code.',
      nearestNote: root.getAttribute('data-l-nearest') || 'No stores within range. Showing the nearest.',
      error: root.getAttribute('data-l-error') || 'The store list could not be loaded. Please refresh the page.',
      approx: root.getAttribute('data-l-approx') || 'Map pin is approximate.',
      noStreet: root.getAttribute('data-l-nostreet') || 'Street address not listed. Map pin shows the general area.',
      countries: { CA: root.getAttribute('data-l-ca') || 'Canada', US: root.getAttribute('data-l-us') || 'USA' }
    };
    this.el = {
      form: root.querySelector('[data-vcl-form]'),
      input: root.querySelector('[data-vcl-input]'),
      submit: root.querySelector('[data-vcl-submit]'),
      chips: Array.prototype.slice.call(root.querySelectorAll('[data-vcl-chip]')),
      count: root.querySelector('[data-vcl-count]'),
      note: root.querySelector('[data-vcl-note]'),
      list: root.querySelector('[data-vcl-list]'),
      more: root.querySelector('[data-vcl-more]'),
      map: root.querySelector('[data-vcl-map]'),
      card: root.querySelector('[data-vcl-card]'),
      cType: root.querySelector('[data-vcl-card-type]'),
      cName: root.querySelector('[data-vcl-card-name]'),
      cAddr: root.querySelector('[data-vcl-card-addr]'),
      cNote: root.querySelector('[data-vcl-card-note]'),
      cMeta: root.querySelector('[data-vcl-card-meta]'),
      cDir: root.querySelector('[data-vcl-card-dir]')
    };
    this.state = { q: '', country: 'All', center: null, sel: null, busy: false };
    this.stores = [];
    this.view = [];
    this.markers = {};
    this.items = {};
    this.shown = this.cfg.page;
    this.narrow = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null; // the theme's phone breakpoint
    this.map = null;
    this.bind();
    this.start();
  }

  Locator.prototype.bind = function () {
    var self = this, el = this.el;
    el.form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(self._t); self.search(el.input.value); });
    el.input.addEventListener('input', function () {
      clearTimeout(self._t);
      self._t = setTimeout(function () {
        self.state.q = el.input.value.trim();
        self.state.center = null;
        self.setNote('');
        self.render();
      }, 120);
    });
    el.chips.forEach(function (c) {
      c.addEventListener('click', function () {
        self.state.country = c.getAttribute('data-vcl-chip');
        el.chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        self.render();
      });
    });
    el.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vcl-id]');
      if (b) self.select(b.getAttribute('data-vcl-id'));
    });
    if (el.more) {
      el.more.addEventListener('click', function () {
        var first = self.shown;
        self.shown += self.cfg.page;
        self.applyPaging();
        var r = self.view[first];
        if (r && self.items[r.s.id]) self.items[r.s.id].focus();
      });
    }
    if (this.narrow) {
      var onChange = function () { self.applyPaging(); };
      if (this.narrow.addEventListener) this.narrow.addEventListener('change', onChange);
      else if (this.narrow.addListener) this.narrow.addListener(onChange);
    }
  };

  Locator.prototype.start = function () {
    var self = this;
    this.el.count.textContent = this.t.loading;
    var mapP = loadLeaflet().then(function (L) { self.initMap(L); }).catch(function () { self.root.classList.add('is-map-failed'); });
    var stores = readData(this.root);
    if (!stores) {
      this.el.count.textContent = '';
      this.setNote(this.t.error);
      return;
    }
    this.stores = stores;
    mapP.then(function () {
      var q = '';
      try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) {}
      q = q.trim().slice(0, 120);
      if (q) { self.el.input.value = q; self.search(q); }
      else self.render();
    });
  };

  Locator.prototype.initMap = function (L) {
    if (this.map || !this.el.map) return;
    var mobile = L.Browser.mobile;
    this.L = L;
    this.map = L.map(this.el.map, {
      zoomControl: false,
      attributionControl: false,
      scrollWheelZoom: false,
      dragging: !mobile,
      tap: false,
      minZoom: 2,
      maxZoom: 18,
      worldCopyJump: true
    }).setView([46, -96], 3);
    L.control.zoom({ position: 'topleft' }).addTo(this.map);
    L.control.attribution({ position: 'bottomright', prefix: false }).addTo(this.map);
    L.tileLayer(TILE_URL, { maxZoom: 19, attribution: TILE_ATTR }).addTo(this.map);
    this.layer = L.layerGroup().addTo(this.map);
    // The mockup's pin is the OpenStreetMap embed marker, i.e. Leaflet's default marker.
    this.icon = L.icon({
      iconUrl: LEAFLET_IMG + 'marker-icon.png', iconRetinaUrl: LEAFLET_IMG + 'marker-icon-2x.png',
      shadowUrl: LEAFLET_IMG + 'marker-shadow.png', iconSize: [25, 41], iconAnchor: [12, 41], shadowSize: [41, 41]
    });
    var self = this;
    // Wheel zoom only after the visitor engages with the map, so page scrolling is never trapped.
    this.map.on('focus click', function () { self.map.scrollWheelZoom.enable(); });
    this.map.on('blur mouseout', function () { self.map.scrollWheelZoom.disable(); });
  };

  Locator.prototype.setNote = function (msg) {
    this.el.note.textContent = msg || '';
    this.el.note.hidden = !msg;
  };

  Locator.prototype.search = function (raw) {
    var self = this, q = String(raw || '').trim().slice(0, 120);
    this.state.q = q;
    this.state.center = null;
    this.setNote('');
    if (!q || !this.stores.length) { this.render(); return; }
    var ql = q.toLowerCase();
    // A store-name match is answered locally; everything else is a place to geocode.
    var nameHit = this.stores.some(function (s) { return s.nameL.indexOf(ql) > -1; });
    if (nameHit || this.state.busy) { this.render(); return; }
    this.state.busy = true;
    this.el.submit.disabled = true;
    this.el.count.textContent = this.t.searching + '…';
    geocode(q).then(function (g) {
      if (self.state.q !== q) return;
      if (!g) g = self.postalFallback(q);
      if (g) self.state.center = g;
      else if (!self.textMatches(ql).length) self.setNote(self.t.notFound);
      self.render({ selectFirst: !!g });
    }).catch(function () {
      if (self.state.q === q) self.render();
    }).then(function () {
      self.state.busy = false;
      self.el.submit.disabled = false;
    });
  };

  // OpenStreetMap knows few full Canadian postal codes. When one is not found, centre on the
  // stores that share its forward sortation area (first 3, then first 2 characters).
  Locator.prototype.postalFallback = function (q) {
    var m = q.toUpperCase().replace(/\s+/g, '').match(/^([ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z])(\d[ABCEGHJ-NPRSTV-Z]\d)?$/);
    if (!m) return null;
    var fsa = m[1], stores = this.stores;
    for (var n = 3; n >= 2; n--) {
      var pre = fsa.slice(0, n), lat = 0, lon = 0, k = 0;
      stores.forEach(function (s) {
        if (s.lat == null || s.country !== 'CA') return;
        if (s.postal.toUpperCase().replace(/\s+/g, '').slice(0, n) === pre) { lat += s.lat; lon += s.lon; k++; }
      });
      if (k) return { lat: lat / k, lon: lon / k, label: fsa, unit: 'km' };
    }
    return null;
  };

  Locator.prototype.textMatches = function (ql) {
    var c = this.state.country;
    return this.stores.filter(function (s) {
      return (c === 'All' || s.country === c) && (!ql || s.hay.indexOf(ql) > -1);
    });
  };

  Locator.prototype.compute = function () {
    var st = this.state, c = st.country;
    if (!st.center) {
      return this.textMatches(st.q.toLowerCase()).map(function (s) { return { s: s, km: null }; });
    }
    var cen = st.center, all = [];
    this.stores.forEach(function (s) {
      if (s.lat == null || (c !== 'All' && s.country !== c)) return;
      all.push({ s: s, km: haversineKm(cen.lat, cen.lon, s.lat, s.lon) });
    });
    all.sort(function (a, b) { return a.km - b.km; });
    var r = this.cfg.radius;
    var within = all.filter(function (x) { return x.km <= r; });
    if (within.length) return within;
    if (all.length) this.setNote(this.t.nearestNote);
    return all.slice(0, this.cfg.nearest);
  };

  Locator.prototype.render = function (opts) {
    opts = opts || {};
    var self = this, st = this.state, el = this.el;
    var rows = this.compute();
    this.view = rows;
    var unit = st.center ? st.center.unit : 'km';

    // count
    var n = rows.length;
    el.count.textContent = n + ' ' + (n === 1 ? this.t.store : this.t.stores);

    // selection: keep the current one if still visible
    var ids = {};
    rows.forEach(function (r) { ids[r.s.id] = r; });
    if (opts.selectFirst || !st.sel || !ids[st.sel]) st.sel = rows.length ? rows[0].s.id : null;

    // list
    var frag = document.createDocumentFragment();
    this.items = {};
    rows.forEach(function (r) {
      var s = r.s;
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vc-locator__item';
      b.setAttribute('data-vcl-id', s.id);
      var top = document.createElement('span'); top.className = 'vc-locator__item-top';
      var nm = document.createElement('span'); nm.className = 'vc-locator__item-name'; nm.textContent = s.name;
      top.appendChild(nm);
      var ds = document.createElement('span'); ds.className = 'vc-locator__item-dist';
      ds.textContent = r.km != null ? fmtDist(r.km, unit) : s.region;
      top.appendChild(ds);
      var ad = document.createElement('span'); ad.className = 'vc-locator__item-addr'; ad.textContent = s.addr;
      b.appendChild(top); b.appendChild(ad);
      if (s.approx) { var nt = document.createElement('span'); nt.className = 'vc-locator__item-note'; nt.textContent = s.noStreet ? self.t.noStreet : self.t.approx; b.appendChild(nt); }
      if (s.country) { var ty = document.createElement('span'); ty.className = 'vc-locator__item-type'; ty.textContent = self.t.countries[s.country]; b.appendChild(ty); }
      li.appendChild(b);
      frag.appendChild(li);
      self.items[s.id] = b;
    });
    el.list.textContent = '';
    if (!rows.length && !el.note.textContent) {
      var e = document.createElement('li');
      e.className = 'vc-locator__empty';
      e.textContent = this.t.empty + (st.q && !st.center ? ' ' + this.t.emptyHint : '');
      frag.appendChild(e);
    }
    el.list.appendChild(frag);
    el.list.scrollTop = 0;
    this.shown = this.cfg.page;
    this.applyPaging();

    this.renderMarkers(rows);
    this.paintSelection(false);
    this.center();
  };

  // Phones show the first `shown` rows and a "Show more" button; wider screens show every row
  // (the list scrolls inside its box, as in the mockup).
  Locator.prototype.applyPaging = function () {
    var paged = !!(this.narrow && this.narrow.matches), shown = this.shown, self = this;
    this.view.forEach(function (r, i) {
      var b = self.items[r.s.id];
      if (b && b.parentNode) b.parentNode.hidden = paged && i >= shown;
    });
    if (this.el.more) this.el.more.hidden = !(paged && this.view.length > shown);
  };

  // A store picked on the map is revealed in the paged list.
  Locator.prototype.reveal = function (id) {
    if (!(this.narrow && this.narrow.matches)) return;
    for (var i = 0; i < this.view.length; i++) {
      if (this.view[i].s.id === id) {
        if (i >= this.shown) {
          this.shown = Math.ceil((i + 1) / this.cfg.page) * this.cfg.page;
          this.applyPaging();
        }
        return;
      }
    }
  };

  Locator.prototype.renderMarkers = function (rows) {
    if (!this.map) return;
    var L = this.L, self = this;
    this.layer.clearLayers();
    this.markers = {};
    rows.forEach(function (r) {
      var s = r.s;
      if (s.lat == null) return;
      var label = s.approx ? s.name + ' (' + (s.noStreet ? self.t.noStreet : self.t.approx) + ')' : s.name;
      var m = L.marker([s.lat, s.lon], { icon: self.icon, title: label, alt: label, keyboard: false, bubblingMouseEvents: false });
      m.on('click', function () { self.select(s.id, { scrollList: true }); });
      m.addTo(self.layer);
      self.markers[s.id] = m;
    });
  };

  // Same view as the mockup's embed: the selected store centred in a fixed bbox around it.
  Locator.prototype.center = function () {
    if (!this.map || !this.state.sel) return;
    var row = null;
    for (var i = 0; i < this.view.length; i++) if (this.view[i].s.id === this.state.sel) { row = this.view[i]; break; }
    if (!row || row.s.lat == null) return;
    var s = row.s;
    this.map.fitBounds([[s.lat - BBOX_LAT, s.lon - BBOX_LON], [s.lat + BBOX_LAT, s.lon + BBOX_LON]], { animate: false });
  };

  Locator.prototype.select = function (id, opts) {
    opts = opts || {};
    this.state.sel = id;
    if (opts.scrollList) this.reveal(id);
    this.paintSelection(!!opts.scrollList);
    this.center();
  };

  Locator.prototype.paintSelection = function (scrollList) {
    var id = this.state.sel, self = this;
    Object.keys(this.items).forEach(function (k) {
      var on = k === id;
      self.items[k].classList.toggle('is-selected', on);
      self.items[k].setAttribute('aria-current', on ? 'true' : 'false');
    });
    Object.keys(this.markers).forEach(function (k) {
      self.markers[k].setZIndexOffset(k === id ? 1000 : 0);
    });
    if (scrollList && this.items[id] && !(this.narrow && this.narrow.matches)) {
      var list = this.el.list, item = this.items[id];
      var top = item.offsetTop - list.offsetTop - 8;
      list.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    // card
    var row = null;
    for (var i = 0; i < this.view.length; i++) if (this.view[i].s.id === id) { row = this.view[i]; break; }
    var el = this.el;
    if (!row) { el.card.hidden = true; return; }
    var s = row.s;
    el.cType.textContent = s.country ? this.t.countries[s.country] : '';
    el.cType.hidden = !s.country;
    el.cName.textContent = s.name;
    el.cAddr.textContent = s.addr;
    if (el.cNote) {
      el.cNote.textContent = s.approx ? (s.noStreet ? this.t.noStreet : this.t.approx) : '';
      el.cNote.hidden = !s.approx;
    }
    var unit = this.state.center ? this.state.center.unit : 'km';
    el.cMeta.textContent = row.km != null ? fmtDist(row.km, unit) + ' ' + (el.cMeta.getAttribute('data-away') || 'away') : '';
    el.cMeta.hidden = row.km == null;
    // Directions use the name and the address line, never the pin, so an approximate pin
    // does not move them.
    var dest = s.name + ', ' + s.addr;
    el.cDir.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
    el.card.hidden = false;
  };

  Locator.prototype.destroy = function () {
    if (this.map) { this.map.remove(); this.map = null; }
  };

  /* ---------- boot ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-vc-locator]').forEach(function (root) {
      if (root._vcLocator) return;
      root._vcLocator = new Locator(root);
    });
  }
  window.VCLocator = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-vc-locator]');
    if (r && r._vcLocator) { r._vcLocator.destroy(); r._vcLocator = null; }
  });
})();
